var _defs, _rect, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoKerin240X50(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 50,
    viewBox: "0 0 240 50",
    role: "img",
    "aria-label": "Szko\\u0142a Rycerska Kerin",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shieldGrad",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ef3b24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#c91f17"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softGlow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 45,
    fill: "#ffffff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8,5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0h18c0 4 3 6 6 6v16c0 8-6 14-15 18c-9-4-15-10-15-18V6c3 0 6-2 6-6z",
    fill: "url(#shieldGrad)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f2d447",
    stroke: "#f2d447",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    filter: "url(#softGlow)",
    transform: "translate(0,-2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 6,
    r: 2.6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "         M23.8 8         L26.2 8         L26.2 28         L28.3 31.7         L25 40         L21.7 31.7         L23.8 28         Z       ",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 12.7h14l-0.3 2.5H18.3z",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    fontFamily: "Arial, Helvetica, sans-serif",
    fill: "#f7e56b",
    textAnchor: "middle",
    filter: "url(#softGlow)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 18,
    y: 26.5,
    fontSize: 8.5,
    fontWeight: 500
  }, "S"), /*#__PURE__*/React.createElement("text", {
    x: 32.4,
    y: 26.5,
    fontSize: 8.5,
    fontWeight: 500
  }, "R")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#d93025",
    fontFamily: "Arial, Helvetica, sans-serif"
  }, /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 18,
    fontSize: 9,
    letterSpacing: 2.2,
    fontWeight: 500
  }, "SZKO\u0141A RYCERSKA"), /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 40,
    fontSize: 18,
    letterSpacing: 9,
    fontWeight: 300
  }, "KERIN"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKerin240X50);
export default __webpack_public_path__ + "static/media/logo_kerin_240x50.e1e82eca2d26b9916c90b4d61fbedd86.svg";
export { ForwardRef as ReactComponent };